export default __webpack_public_path__ + "static/cambodia-bike-tour-6-7e6964f3725cb835cf2822313660f7ea.jpeg";